import cn from "classnames";
import { ErrorMessage, Field, FieldProps } from "formik";
import { IMaskInput } from "react-imask";
import { ChangeEvent } from "react";
import { MaskedOptions } from "imask";

import styles from "./form-field.module.scss";

interface FormFieldInterface
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  id?: string;
  value?: string;
  label?: string;
  icon?: string;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  errClassName?: string;
  type?: string;
  dimension?: string;
  mask?: MaskedOptions<any>["mask"];
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onAccept?: (value: any) => void;
}

const FormField = ({
  label,
  icon,
  mask,
  dimension,
  ...props
}: FormFieldInterface) => {
  return (
    <div className={cn(styles["form-field-wrapper"], props.className)}>
      {label && (
        <label htmlFor={props.id || props.name} aria-disabled={props.disabled}>
          {label}
        </label>
      )}

      {icon && (
        <div
          className={cn(styles["form-field__icon"], {
            [styles["form-field__icon--disabled"]]: props.disabled
          })}
        >
          <img src={icon} alt={`field-${props.name}-icon`} />
        </div>
      )}

      <div className={styles["form-field__input-wrapper"]}>
        <Field name={props.name}>
          {({ field }: FieldProps) =>
            mask ? (
              <IMaskInput
                {...field}
                {...props}
                mask={mask}
                unmask="typed"
                className={cn(styles["form-field__input"], {
                  [styles["form-field__input--with-icon"]]: icon
                })}
                onAccept={(value) => {
                  props.onAccept(value);
                }}
              />
            ) : (
              <input
                {...field}
                {...props}
                className={cn(styles["form-field__input"], {
                  [styles["form-field__input--with-icon"]]: icon
                })}
              />
            )
          }
        </Field>

        {dimension && <span>{dimension}</span>}
      </div>

      <ErrorMessage
        component="div"
        className={cn(styles["error"], props.errClassName)}
        name={props.name}
      />
    </div>
  );
};

export default FormField;
